import { combineLatest, Observable, of } from 'rxjs';

export function combineLatestOrEmpty<T>(observables: Array<Observable<T>>) {
  return observables.length ? combineLatest(observables) : of([]);
}
